import * as evironmentModels from '../models/environmentModels';

export function getEnvironment(){
    return Object.assign({},evironmentModels.environment,{
        os: getOsDetails(),
        browser: getBrowserDetails(),
        isDevice: isDevice(),
        window: getWindowDetails(),

    });
}

function getOsDetails(){
    let agent = evironmentModels.header.join(' ');
    let osDetails = {};
    let os = evironmentModels.os;
    if (window.device && window.device.model.toLowerCase().indexOf("ipad") >= 0) {
        for (let i = 0; i < os.length; i++) {
            if (os[i].name == 'iPad') {
                osDetails = Object.assign({},os[i]);
                break;
            }
        }
    } else {
        osDetails = Object.assign({},matchItem(agent, os));
    }
    return osDetails;
}


function getBrowserDetails(){
    let agent = evironmentModels.header.join(' ');
    return  matchItem(agent, evironmentModels.browser);
}

function isDevice(){
    let deviceAgent = navigator.userAgent.toLowerCase();
    let iDevice = deviceAgent.match(/(iphone|ipod|ipad|android)/) ? true : false;
    return iDevice;
}

function getWindowDetails(){
    let isiPhone = navigator.userAgent.match(/(iPhone)/g) ? true : false;
    let windowSize = "lg";
    if (isiPhone) {
        windowSize = 'xs';
    } else {
        let w = window.innerWidth;
        if (w <= 767) { windowSize = "xs"; }
        if (w > 767 && w < 992) { windowSize = "sm"; }
        if (w >= 992 && w < 1200) { windowSize = "md"; }
    }

    return {
        size: windowSize,
        width: window.innerWidth,
        height: window.innerHeight,
        orientation: window.innerWidth > window.innerHeight ? "landscape" : "portrait"
    };
}

function matchItem(string, data) {
    let i = 0,
        j = 0,
        regex,
        regexv,
        match,
        matches,
        version;

    for (i = 0; i < data.length; i += 1) {
        regex = new RegExp(data[i].value, 'i');
        match = regex.test(string);
        if (match) {
            regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
            matches = string.match(regexv);
            version = '';
            if (matches) {
                if (matches[1]) {
                    matches = matches[1];
                }
            }
            if (matches) {
                matches = matches.split(/[._]+/);
                for (j = 0; j < matches.length; j += 1) {
                    if (j === 0) {
                        version += matches[j] + '.';
                    } else {
                        version += matches[j];
                    }
                }
            } else {
                version = '0';
            }
            return {
                name: data[i].name,
                version: parseFloat(version)
            };
        }
    }
    return { name: 'unknown', version: 0 };
}


/** WEBPACK FOOTER **
 ** ./src/helpers/environmentHelper.js
 **/